import request from '../utils/request'

export function infoList(data) { // 我的报名列表
  return request({
    url: '/api/signup/info/index',
    method: 'POST',
    data
  })
}

export function h5Wechatpay(params) { // 微信h5支付
  return request({
    url: '/api/signup/info/h5Wechatpay',
    method: 'GET',
    params
  })
}

export function wxWechatPay(params) { // 微信公众号支付
  return request({
    url: '/api/signup/info/mpWechatpay',
    method: 'GET',
    params
  })
}

export function wxNotify(params) { // 微信h5支付回调
  return request({
    url: '/api/signup/info/wxNotify',
    method: 'GET',
    params
  })
}

export function h5Alipay(params) { // 支付宝h5支付
  return request({
    url: '/api/signup/info/h5Alipay',
    method: 'GET',
    params
  })
}

export function alipayNotify(data) { // 支付宝支付回调
  return request({
    url: '/api/signup/info/alipayNotify',
    method: 'POST',
    data
  })
}

export function alipayReturn(data) { // 支付宝支付同步回调
  return request({
    url: '/api/signup/info/alipayReturn',
    method: 'POST',
    data
  })
}
